export default {"mainContainer":"xy8hS","subContainer":"YqC4t"};